import { themes, videoTheme } from '@statsbomb/kitbag-components';
import { ThemeProvider as StatsbombThemeProvider } from '@statsbomb/kitbag-themes';
import PropTypes from 'prop-types';
import React from 'react';
import { DEFAULT_THEME_TYPE } from '../atoms/theme';

function VideoTheme({ applyGlobalStyles, children, themeId }) {
  let sbTheme;

  if (themeId) {
    sbTheme = themes.find(({ key }) => key === themeId) || videoTheme;
  } else {
    sbTheme = videoTheme[DEFAULT_THEME_TYPE];
  }

  return (
    <StatsbombThemeProvider
      applyGlobalStyles={applyGlobalStyles}
      theme={sbTheme}
    >
      {children}
    </StatsbombThemeProvider>
  );
}

VideoTheme.propTypes = {
  applyGlobalStyles: PropTypes.bool,
  children: PropTypes.node.isRequired,
  themeId: PropTypes.string,
};

VideoTheme.defaultProps = {
  applyGlobalStyles: true,
  themeId: undefined,
};

export default VideoTheme;
